import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _REBATE_RECEIPIENT_TY, _REBATE_PAYMENT_TYPE_, _REBATE_PROVIDER_VS_T;

import _invert from 'lodash/invert';
export var REBATE_TYPES = {
  REBATE: 'REBATE',
  DEALER_CASH: 'DEALER_CASH'
};
export var REBATE_TAX_TYPES = {
  PRE_TAX_REBATE: 'PRE_TAX_REBATE',
  POST_TAX_REBATE: 'POST_TAX_REBATE',
  DEFAULT_TAX_REBATE: 'PRE_TAX_REBATE'
};
export var REBATE_RECEIPIENT_TYPES = (_REBATE_RECEIPIENT_TY = {}, _defineProperty(_REBATE_RECEIPIENT_TY, REBATE_TYPES.REBATE, 1), _defineProperty(_REBATE_RECEIPIENT_TY, REBATE_TYPES.DEALER_CASH, 2), _REBATE_RECEIPIENT_TY);
export var RECEIPIENT_TYPE_TO_REBATE_TYPE = _invert(REBATE_RECEIPIENT_TYPES);
export var REBATE_PAYMENT_TYPE_CODES = {
  CASH: 5,
  LEASE: 10,
  RETAIL: 11,
  ALL_PAYMENT_TYPES: 1000
};
export var REBATE_PAYMENT_TYPE_CODE_VS_LABEL = (_REBATE_PAYMENT_TYPE_ = {}, _defineProperty(_REBATE_PAYMENT_TYPE_, REBATE_PAYMENT_TYPE_CODES.CASH, __('Cash')), _defineProperty(_REBATE_PAYMENT_TYPE_, REBATE_PAYMENT_TYPE_CODES.LEASE, __('Lease')), _defineProperty(_REBATE_PAYMENT_TYPE_, REBATE_PAYMENT_TYPE_CODES.RETAIL, __('Loan')), _defineProperty(_REBATE_PAYMENT_TYPE_, REBATE_PAYMENT_TYPE_CODES.ALL_PAYMENT_TYPES, __('All Payment Type')), _REBATE_PAYMENT_TYPE_);
export var REBATE_PROVIDER = {
  MARKET_SCAN: 'mscan',
  GM: 'gm',
  MOTO_INSIGHT: 'motoinsight'
};
export var REBATE_TIERS = {
  TIER1: 'TIER1',
  TIER2: 'TIER2'
};
export var REBATE_PROVIDER_VS_TIRE = (_REBATE_PROVIDER_VS_T = {}, _defineProperty(_REBATE_PROVIDER_VS_T, REBATE_TIERS.TIRE_1, [REBATE_PROVIDER.MARKET_SCAN]), _defineProperty(_REBATE_PROVIDER_VS_T, REBATE_TIERS.TIRE_2, [REBATE_PROVIDER.GM, REBATE_PROVIDER.MOTO_INSIGHT]), _REBATE_PROVIDER_VS_T);
export var REBATE_FILTER_TYPES = {
  TERM: 'Payment Term',
  PAYMENT_TYPE: 'Payment Type',
  PROGRAM_TYPE: 'Program Type',
  CUSTOMER_TYPE: 'Customer Type',
  DELIVERY_TYPE: 'Delivery Type',
  DELIVERY_DATE: 'Delivery Date',
  GEO_CONFLICTS: 'Region',
  REGION_ID: 'Region Id'
};
export var REBATE_FILTERS_FOR_PROGRAM_TYPE = {
  STANDARD: {
    code: 'Standard',
    label: 'Standard'
  },
  SUBVENTED: {
    code: 'Subvented',
    label: 'Subvented'
  }
};
export var REBATE_FILTERS_PAYMENT_TYPES = {
  CASH: {
    code: 'CSH',
    label: 'Cash'
  },
  LOAN: {
    code: 'FIN',
    label: 'Loan'
  },
  LEASE: {
    code: 'LSE',
    label: 'Lease'
  },
  BALLOON: {
    code: 'BAL',
    label: 'Balloon'
  },
  ALL: {
    code: 'All',
    label: 'All'
  }
};
export var REBATE_FILTERS_FOR_DELIVERY_TYPE = {
  ALL: {
    code: 'All',
    label: 'All'
  },
  RETAIL_LEASE_INDIVIDUAL: {
    code: '010',
    label: 'Retail Lease - Individual'
  },
  INDIVIDUAL: {
    code: '015',
    label: 'Individual'
  }
};